import { render, staticRenderFns } from "./number-slider-hight-light-images.vue?vue&type=template&id=21a695dd&"
import script from "./number-slider-hight-light-images.vue?vue&type=script&lang=ts&"
export * from "./number-slider-hight-light-images.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\calculator-common\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21a695dd')) {
      api.createRecord('21a695dd', component.options)
    } else {
      api.reload('21a695dd', component.options)
    }
    module.hot.accept("./number-slider-hight-light-images.vue?vue&type=template&id=21a695dd&", function () {
      api.rerender('21a695dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/question-components/number-slider-hight-light-images/number-slider-hight-light-images.vue"
export default component.exports